// @ts-nocheck
import { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { RefreshCw, Save } from 'lucide-react'
import { apiService } from '../services/api'

const PtrRecords = () => {
  const [editing, setEditing] = useState<any>(null)
  const { data, isLoading, refetch } = useQuery('ptr-records', () => apiService.getPtrRecords(), { refetchInterval: 60000 })

  const updatePtr = useMutation(
    () => apiService.updatePtrRecord(editing.id, { value: editing.value, ttl: editing.ttl, apply: true }),
    {
      onSuccess: () => {
        setEditing(null)
        refetch()
      },
      onError: (error: any) => alert(error?.response?.data?.message || 'Failed to update PTR'),
    }
  )

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">PTR Records</h2>
          <p className="text-slate-500">Update reverse DNS hostnames and apply after validation</p>
        </div>
        <button onClick={() => refetch()} className="p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg">
          <RefreshCw className="h-5 w-5" />
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <table className="min-w-full divide-y divide-slate-200">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Reverse Zone</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">Host</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">PTR Hostname</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase text-slate-500">TTL</th>
              <th className="px-4 py-3 text-right text-xs font-semibold uppercase text-slate-500">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {isLoading ? (
              <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-500">Loading PTR records...</td></tr>
            ) : (data?.data || []).length === 0 ? (
              <tr><td colSpan={5} className="px-4 py-10 text-center text-slate-500">No PTR records found</td></tr>
            ) : (
              data.data.map((record: any) => {
                const isEditing = editing?.id === record.id
                return (
                  <tr key={record.id} className="hover:bg-slate-50">
                    <td className="px-4 py-3 text-sm font-medium text-slate-900">{record.zone_name}</td>
                    <td className="px-4 py-3 text-sm text-slate-600">{record.name}</td>
                    <td className="px-4 py-3">
                      {isEditing ? (
                        <input className="w-full px-3 py-2 border rounded-lg" value={editing.value} onChange={e => setEditing({ ...editing, value: e.target.value })} />
                      ) : (
                        <span className="text-sm text-slate-700">{record.value}</span>
                      )}
                    </td>
                    <td className="px-4 py-3">
                      {isEditing ? (
                        <input className="w-24 px-3 py-2 border rounded-lg" type="number" value={editing.ttl || 3600} onChange={e => setEditing({ ...editing, ttl: e.target.value })} />
                      ) : (
                        <span className="text-sm text-slate-600">{record.ttl || 3600}</span>
                      )}
                    </td>
                    <td className="px-4 py-3 text-right">
                      {isEditing ? (
                        <div className="flex justify-end gap-2">
                          <button onClick={() => setEditing(null)} className="px-3 py-2 border rounded-lg text-sm">Cancel</button>
                          <button onClick={() => updatePtr.mutate()} disabled={updatePtr.isLoading} className="inline-flex items-center gap-2 px-3 py-2 bg-sky-600 text-white rounded-lg text-sm disabled:opacity-60">
                            <Save className="h-4 w-4" /> Apply
                          </button>
                        </div>
                      ) : (
                        <button onClick={() => setEditing({ ...record })} className="px-3 py-2 border rounded-lg text-sm hover:bg-slate-100">Edit</button>
                      )}
                    </td>
                  </tr>
                )
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default PtrRecords
